import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS } from "./translations";
import { EXTRA } from "./translations-extra";

const deepMerge = (base, extra) => {
  const out = { ...(base || {}) };
  for (const k of Object.keys(extra || {})) {
    const v = extra[k];
    out[k] = v && typeof v === "object" && !Array.isArray(v) ? deepMerge((base || {})[k], v) : v;
  }
  return out;
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("miora-lang") || "fr");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("miora-lang", l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: deepMerge(TRANSLATIONS[lang], EXTRA[lang]), isRtl: lang === "ar" }),
    [lang]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
